import "./ScaffoldingInRichmond.module.css";
import Header from "@/reusable_sections/Header";
import Richmond from "./sections/Richmond";
import Coverage from "./sections/Coverage";
import RichmondAccess from "./sections/RichmondAccess";
import FaqRichmond from "./sections/FaqRichmond";
import QuoteCTA from "./sections/QuoteCTA";
import Footer from "@/reusable_sections/Footer";
export default function ScaffoldingInRichmondPage() {
  return <div>
      <Header />
      <Richmond />
      <Coverage />
      <RichmondAccess />
      <FaqRichmond />
      <QuoteCTA />
      <Footer />
    </div>;
}